/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ naam: NonNullable<unknown> }} Planning_Rooster_Lesuur_VerwijderenInputs */

const nl_planning_rooster_lesuur_verwijderen = /** @type {(inputs: Planning_Rooster_Lesuur_VerwijderenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.naam} verwijderen`)
};

/**

* @param {Planning_Rooster_Lesuur_VerwijderenInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const planning_rooster_lesuur_verwijderen = /** @type {((inputs: Planning_Rooster_Lesuur_VerwijderenInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planning_Rooster_Lesuur_VerwijderenInputs, { locale?: "nl" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_planning_rooster_lesuur_verwijderen(inputs)
});
export { planning_rooster_lesuur_verwijderen as "planning.rooster.lesuur_verwijderen" }